<template>
  <div class="kk-rightpanel__main">
    <div
      data-test-id="sidebar-teams"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': true,
        'kk-rightpanel__main-item-open': false,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.Settings]" />
    </div>

    <!-- Style -->
    <div
      data-test-id="sidebar-players"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.Style]" />
    </div>

    <!-- File -->
    <div
      data-test-id="sidebar-players"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.File]" />
    </div>

    <!-- Players -->
    <div
      data-test-id="sidebar-players"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.Edit]" />
    </div>

    <!-- Views -->
    <div
      data-test-id="sidebar-processes"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.View]" />
    </div>

    <!-- Insert -->
    <div
      data-test-id="sidebar-processes"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.Insert]" />
    </div>

    <!-- Tools -->
    <div
      data-test-id="sidebar-processes"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons[BlueZoneItemTypes.Util]" />
    </div>

    <!-- Options -->
    <div
      v-if="showOptions"
      data-test-id="sidebar-options"
      class="kk-rightpanel__main-item"
      :class="{
        'kk-rightpanel__main-item-active': false,
        'kk-rightpanel__main-item-open': true,
      }"
    >
      <custom-icon class="kk-rightpanel__icon" :class-name="icons.Options" />
    </div>

    <!-- grow container -->
    <div style="flex-grow: 1"></div>
  </div>
</template>

<script>
import { icons, BlueZoneItemTypes } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  data() {
    return {
      icons: icons,
      BlueZoneItemTypes: BlueZoneItemTypes,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-rightpanel {
  &__icon {
    font-size: 22px;
    color: @kk-color-primary-blue !important;
  }
  &__main {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    &-item {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      background-color: #d5e4ff;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      position: relative;
      cursor: pointer;

      &-open {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.2));
        }
      }

      &-active {
        background-color: #fff;
        color: #7f7f7f;
        cursor: pointer;
        &::before {
          background: none;
        }
      }
      &:hover:not(&-active) {
        background-color: #62dff7;
      }
    }
  }
}
</style>
